import styled from "styled-components";
import { PageWrapper } from "@containers/PageWrapper";

const EsignPageWrapper = styled(PageWrapper)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .content-box {
    width: 100%;
    box-sizing: border-box;
    max-width: 1200px;
    padding: 0 20px;
    margin: 0 auto;
  }

  .modal-action-button {
        align-self: center;
    }
`;

export default EsignPageWrapper;
